import { createApiCall } from 'lib/base';

const POST_ACTIVE_INVESTMENT_PLANS_API_ID =
  'INVESTCORE/POST_ACTIVE_INVESTMENT_PLANSL_API';

const apiCall = createApiCall(
  POST_ACTIVE_INVESTMENT_PLANS_API_ID,
  ({ id, version, payload }) => ({
    endpoint: `/api/admin/employee-programs/${id}/investment-plans/${version}/active`,
    method: 'POST',
    notify: true,
    isReturn: false,
  })
);

export default apiCall;
